import { render, staticRenderFns } from "./PersonLpa.vue?vue&type=template&id=d7850be2"
import script from "./PersonLpa.vue?vue&type=script&lang=js"
export * from "./PersonLpa.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports